/**
 * Global event stream tab.
 *
 * Body lives in `EventsStream`, which is reused by the per-Service /
 * per-Pool / per-Pod Events tabs. In Global mode, scope filters are
 * read from `useSearchParams` (so deep-linking from "events for this
 * pool" buttons elsewhere in the app keeps working) and rendered as
 * removable chips.
 *
 *   ?tab=events
 *   ?tab=events&service_id=1                        scope to one service
 *   ?tab=events&pool_id=3                           scope to one pool
 *   ?tab=events&replica_id=42&pool_id=3             scope to one replica
 */
import { EventsStream } from "@/components/EventsStream";

export function GlobalEvents() {
  return <EventsStream />;
}
